import React, { useEffect, useState } from 'react';
import AttendanceDetailPopup from './AttendanceDetailPopup';
import { API } from 'aws-amplify';
import { Button, CircularProgress, Box, Paper, Typography, Chip } from '@mui/material';
import TableComponent from '../UI/TableComponent';
import LoadingScreen from '../UI/LoadingScreen';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const AttendanceTable = ({ studentsData }) => {
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [attendanceData, setAttendanceData] = useState([]);
    const [fullAttendanceData, setFullAttendanceData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedName, setSelectedName] = useState("");
    const [openPopup, setOpenPopup] = useState(false);

    const handleRowClick = (params) => {
        let email = params.row.email;
        setSelectedName(params.row.name)
        let resultData = [];
        fullAttendanceData.map(item => {
            if (item.email === email.toString()) {
                resultData.push(item);
            }
        })
        setSelectedStudent(resultData);
        setOpenPopup(true);
    };

    const handleClosePopup = () => {
        setSelectedStudent([]);
        setOpenPopup(false);
    };

    const columns = [
        { 
            field: 'S. No', 
            headerName: 'S. No', 
            width: 80, 
            renderCell: (params) => (
                <Chip 
                    label={params.row.id} 
                    size="small" 
                    sx={{ 
                        backgroundColor: '#f0f9ff', 
                        color: '#0369a1',
                        fontWeight: 600
                    }} 
                />
            )
        },
        { 
            field: 'name', 
            headerName: 'Name', 
            width: 200,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PersonIcon sx={{ color: '#6366f1', fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, color: '#374151' }}>
                        {params.value}
                    </Typography>
                </Box>
            )
        },
        { 
            field: 'email', 
            headerName: 'Email', 
            width: 280,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <EmailIcon sx={{ color: '#10b981', fontSize: 18 }} />
                    <Typography variant="body2" sx={{ color: '#64748b' }}>
                        {params.value}
                    </Typography>
                </Box>
            )
        },
        { 
            field: 'phone', 
            headerName: 'Phone', 
            width: 180,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PhoneIcon sx={{ color: '#f59e0b', fontSize: 18 }} />
                    <Typography variant="body2" sx={{ color: '#64748b' }}>
                        {params.value}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'actions',
            headerName: 'Actions',
            sortable: false,
            filterable: false,
            width: 200,
            renderCell: (params) => (
                <Button 
                    variant="contained" 
                    startIcon={<VisibilityIcon />}
                    onClick={() => handleRowClick(params)}
                    sx={{
                        fontSize: '12px', 
                        textTransform: 'capitalize',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '8px',
                        px: 2,
                        py: 1,
                        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #5a6fd8 0%, #684a94 100%)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    View Logs
                </Button>
            ),
        },
    ];
    const getUsers = (emails) => {
        let apiName = 'Node-API';
        let path = ''; //replace this with the path you have configured on your API
        let params = {
            body:
            {
                "command": "getUsers"
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
        API.post(apiName, path, params).then(response => {
            if (response.data.statusCode === 200) {
                let result = JSON.parse(response.data.body);
                let resultData = [];
                result.users.map(item => {
                    emails.map((email, index) => {
                        if (email === item.email.S && item.user_role.S === "Student") {
                            let data = {
                                id: index + 1,
                                name: item.fname.S + " " + item.lname.S,
                                fname: item.fname.S,
                                lname: item.lname.S,
                                email: item.email.S,
                                phone: item.phone.S
                            };
                            resultData.push(data);
                        }
                    })
                })
                //console.log(resultData)
                setAttendanceData(resultData);
                setIsLoading(false);
            }
        }
        ).catch(error => {
            console.log(error, 'Unable to load the data. Please try again.');
        });
    };
    const getAttendance = () => {
        let apiName = 'Node-API';
        let path = ''; //replace this with the path you have configured on your API
        let params = {
            body:
            {
                "command": "getAttendance"
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
        API.post(apiName, path, params).then(response => {
            if (response.data.statusCode === 200) {
                let result = JSON.parse(response.data.body);
                let uniqueEmails = [];
                let resultData = [];

                result.attendance.forEach((item, index) => {
                    let data1 = {
                        id: index + 1,
                        time: item.startTime.S + " - " + item.endTime.S,
                        email: item.email.S,
                        agenda: item.agenda.S,
                        date: item.date.S,
                        status: item.status.S
                    };
                    resultData.push(data1)
                    if (!uniqueEmails.includes(item.email.S)) {
                        uniqueEmails.push(item.email.S);
                    }
                });
                getUsers(uniqueEmails);
                //console.log(resultData);
                setFullAttendanceData(resultData);

            }
        }
        ).catch(error => {
            console.log(error, 'Unable to load the data. Please try again.');
            setIsLoading(false);
        });
    };

    useEffect(() => {
        getAttendance();
    }, [])

    return (
        <Box sx={{ p: 2, backgroundColor: '#f8fafc', minHeight: 'auto' }}>
            <Paper 
                elevation={3} 
                sx={{ 
                    p: 2, 
                    borderRadius: '16px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                }}
            >
                <Typography variant="h5" sx={{ 
                    mb: 2, 
                    fontWeight: 700, 
                    color: '#1e293b',
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>
                    Student Attendance Overview
                </Typography>
                
                {isLoading ? (
                    <LoadingScreen message="Loading attendance records..." />
                ) : (
                    <Box sx={{ 
                        backgroundColor: '#ffffff',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
                    }}>
                        <TableComponent rows={attendanceData} columns={columns} />
                        <AttendanceDetailPopup open={openPopup} name={selectedName} attendance={selectedStudent} onClose={handleClosePopup} />
                    </Box>
                )}
            </Paper>
        </Box>
    );
};

export default AttendanceTable;
